<template>
    <div class="body_book">
        <div class="top">
            <p class="top-1">{{book.bookTypeName}}</p>
            <p class="top-2">(共{{book.bookList.length}}本)</p>
        </div>
        <div class="middle">
                <div class="middle-1">
                        <el-carousel  type="card" 
                        height="150rem"
                        :autoplay="false" 
                        trigger="click"
                        indicator-position="none"
                        arrow = "always"
                        :loop="false"
                        @change="carouselChange"
                        ref="carousel"
                        >
                            <el-carousel-item v-for='(item, index) in book.bookList' :key="index">
                                <el-image class="image" :src= item.cover ></el-image>
                                <p>
                                  {{item.year}}
                                  <span v-if="item.grade">{{item.grade}} <span v-if="item.bookVersion">{{item.bookVersion}}</span></span>
                                </p>
                                <div class="disable_book" v-if="item.status==='1'">已禁用</div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="middle-2">
                        <ul>
                            <li v-for="(item,index) in book.bookList[currentIdx].catalogList" :key="index">
                                <el-tooltip class="item" effect="light" :content="item.type+':'+item.paperTotal+'套'" placement="top-start">
                                    <p :class="['li-2',book.bookList[currentIdx].status=='1'?'li-2-disable':'']">{{item.type}}: <span :class="['li-2',book.bookList[currentIdx].status=='1'?'li-2-disable':'']">{{item.paperTotal}}套</span></p>
                                </el-tooltip>
                                <el-button round size="mini" plain :class="[item.status=='0'?'li-3_disabled':'li-3_enable',book.bookList[currentIdx].status=='1'?'li_3_disabled_all':'']" @click='enableCatalog(item, book.bookList[currentIdx])'>{{item.status=='0'?'禁用':'启用'}}</el-button> 
                                <el-button round  size="mini" plain :class="['li-4',book.bookList[currentIdx].status=='1'?'li_3_disabled_all':'']" @click='toCatalog(book.bookList[currentIdx],item.type)'>编辑</el-button> 
                            </li>
                        </ul>
                    </div>
                <div style="border-top: 1rem solid #E9E9E9;"></div>
        </div>
        <div class="bottom">
            <popDrop class="bottom-1" fontsize="16rem" @option="option" top="2rem" left="8rem" size=0.5 dropdownText1="编辑题源" dropdownText2="禁用题源" dropdownText3="删除题源" dropdownText5="生成二维码" dropdownText4="图书资源上传"></popDrop>
           
            <div class="bottom-2" @click='toCatalog(book.bookList[currentIdx])'><i style="margin-right: 2rem" class="el-icon-circle-plus-outline"></i>新增模块</div> 
        </div>
        <div class="book_mask" v-if="book.bookTypeStatus=='0'?false:true">
            <el-button @click="enableQuestion">启用题源</el-button>
            <img class="image" src="../static/forbidden.png">
        </div>
        <newQuestionDia 
        :dialogVisible="newQuestionVisible" 
        v-bind="$attrs" 
        :versionList="versionList"
        :gradeList="gradeList"
        @dialogClose="dialogClose"
        @newOrUpdateQuestion="newOrUpdateQuestion"
        :title="title"
        :book="book.bookList[this.currentIdx]"
        >
        </newQuestionDia>
        
        <el-dialog
            title="图书资源上传"
            :visible.sync="uploadVosible"
            class="codeDialog"
            width="400px">
            <el-upload
                class="upload-demo"
                drag
                :action="uploadBookAddress"
                multiple
                :headers="customHeaders"
                :on-change="handleChange"
                :file-list="fileList"
                :before-upload="beforeUploadBook" :on-success="handleBookSuccess" :on-error="handleBookError"
                :data="{'bookId':book.bookList[currentIdx]['id']}">
                <!-- <i class="el-icon-upload"></i>:show-file-list="false" -->
                <img src="../../../assets/images/upload_icon.png" class="el-icon-upload">
                <div class="el-upload__text">支持ZIP格式，将文件拖到此处，或<em style="color:#0BAE6A">点击上传</em></div>
                <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>

            <!-- <el-upload
                class="upload-demo"
                drag
                action="https://jsonplaceholder.typicode.com/posts/"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload> -->

            <div class="linkBox">
                <span class="linkText">链接：</span>
                <el-tooltip class="item" effect="light" :content="linkUrl" placement="top-start">
                    <div class="linkContent">
                        {{linkUrl}}
                    </div>
                </el-tooltip>
                <img class="linkIcon" @click="copyLink" src="../../../assets/images/icon-handle-copy.png">
            </div>
            <div class="uploadBtnBox">
                <el-button @click="saveBook">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="预览"
            :visible.sync="qrCodeShow"
            class="codeDialog"
            :width="codeType=='app'?'350rem':'620rem'">
            <div class="coilingQrCode" v-show="codeType=='app'">
                <div class="qrCodeBox">
                    <!-- <canvas style="width: 200rem;height: 200rem;" ref="coilingqrcode3"></canvas> -->
                    <img style="width: 200rem;height: 200rem;" :src="imageUrl.appImg">
                </div>
            </div>
            <div class="coilingQrCode" v-show="codeType=='question'">
                <div class="qrCodeBox">
                    <!-- <canvas style="width: 200rem;height: 200rem;" ref="coilingqrcode"></canvas> -->
                    <img style="width: 200rem;height: 200rem;" :src="imageUrl.teacherImg">
                    <span class="qrCodeText">老师端</span>
                </div>
                <div class="qrCodeBox">
                    <!-- <canvas style="width: 200rem;height: 200rem;" ref="coilingqrcode2"></canvas> -->
                    <img style="width: 200rem;height: 200rem;" :src="imageUrl.studentImg">
                    <span class="qrCodeText">学生端</span>
                </div>
            </div>
            <div class="qrCodeBtnBox">
                <el-button @click="downloadImage">下载</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="生成二维码"
            :visible.sync="qrCodeVosible"
            width="30%">
            <div class="dialogBox">
                <div class="checkBox">
                    <el-checkbox v-model="appChecked" @change="appCodeChange">下载app码</el-checkbox>
                    <span class="previewText" @click="previewAppCode(appRadio,true)">预览</span>
                </div>
                <div class="radioBox">
                    <el-radio v-model="appRadio" label="1" @input="radioClick">万维中考APP</el-radio>
                </div>
                <div class="checkBox">
                    <el-checkbox v-model="questionChecked" @change="questionCodeChange">试题预览码</el-checkbox>
                    <span class="previewText" @click="previewCode(questionRadio,true)">预览</span>
                </div>
                <div class="radioBox">
                    <el-radio-group v-model="questionRadio" @input="questionCodeChange">
                        <el-radio label="1">万维中考APP</el-radio>
                        <el-radio label="2">试题研究logo</el-radio>
                        <el-radio label="3">面对面logo</el-radio>
                    </el-radio-group>
                </div>
                <div class="btnBox">
                    <button class="loadBtn" @click="batchDownImage">下载</button>
                </div>
            </div>
        </el-dialog>
        <div style="display:none">
            <canvas style="width: 200rem;height: 200rem;" ref="coilingqrcode"></canvas>
            <canvas style="width: 200rem;height: 200rem;" ref="coilingqrcode2"></canvas>
            <canvas style="width: 200rem;height: 200rem;" ref="coilingqrcode3"></canvas>
        </div>
    </div>
</template>
<script>
import popDrop from './popdrop'
import newQuestionDia from './newQuestionDia'
import {questionOptions} from '@/constants/constants'
import {regionCode,getRegionCode} from '../../../utils/util'
import { uploadBook } from "@/constants/constants";
import QRCode from "qrcode";
import { getToken } from '@/utils/auth';
export default {
    name: 'bookItem',
    components: {
        popDrop,
        newQuestionDia
    },
    props: {
        book:{
            type: Object,
            default: ()=>{}
        },
        regionFullName:{
            type: String,
            default: ''
        },
        _refreshFlag:{
            type: Boolean,
            default: false
        },
        pageIndex:{
            type: Number,
            default: 0
        },
        gradeList: Array,
        versionList: Array
    },
    watch:{

        //重置分页重置数据
        pageIndex:{
            handler(newVal){
                if(newVal){
                    this.$nextTick(() => {
                        this.$refs.carousel.setActiveItem(0)
                        this.currentIdx = 0
                    })
                }
            },
            immediate:true
        },
        _refreshFlag:{
            handler(newVal){
                if(newVal){
                    this.$nextTick(() => {
                        this.$emit('refreshFlagToFalse')
                    })
                }
            },
            immediate:true
        }
    },
    data() {
        return {
            customHeaders:{
                'Authorization':getToken()
            },
            newQuestionVisible:false,
            currentIdx:0,
            title:'',
            qrCodeVosible: false,
            qrCodeShow: false,
            appChecked: false,
            questionChecked: false,
            appRadio: '',
            questionRadio: '',
            imageUrl: {
                appImg: "",
                teacherImg: "",
                studentImg: ""
            },
            imageName: {
                app: "",
                teacher: "",
                student: ""
            },
            codeType: '',
            uploadVosible: false,
            uploadBookAddress: uploadBook,
            linkUrl: '',
            fileList: []
        }
    },
    methods: {
        handleChange(file,fileList){
            console.log(file,fileList)
            if (fileList.length>0) {
                this.fileList=[fileList[fileList.length-1]]
            }
        },
        copyLink() {
            if(!this.linkUrl){
                return;
            }
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard
                .writeText(this.linkUrl)
                .then(() => {
                    this.$message.success('复制成功')
                })
                .catch(() => {
                    this.$message.error('复制失败')
                })
            } else {
                // 创建text area
                const textArea = document.createElement('textarea')
                textArea.value = this.linkUrl
                // 使text area不在viewport，同时设置不可见
                document.body.appendChild(textArea)
                textArea.focus()
                textArea.select()
                return new Promise((resolve, reject) => {
                    // 执行复制命令并移除文本框
                    document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
                    textArea.remove()
                }).then(() => {
                    this.$message.success('复制成功')
                }).catch(() => {
                    this.$message.error('复制失败')
                })
            }
        },
        beforeUploadBook(file){
            // this.isLoading = true
            console.log(file);
            const isAudio = file.type === "application/x-zip-compressed";
            if (!isAudio) {
                // this.isLoading = false
                this.$message.error("请上传ZIP文件!");
            }
            return isAudio
        },
        handleBookSuccess(res){
            // this.isLoading = false
            console.log(res)
            this.linkUrl = res.data;
            this.$message.success('上传成功!')
            // this.showAudio(res)
        },
        handleBookError(){
            // this.isLoading = false
            this.$message.error('上传失败,请检查网络并重新上传!')
        },
        saveBook(){
            console.log(this.book.bookList[this.currentIdx])
            this.uploadVosible = false
        },
        previewAppCode(type,bool){  //app码预览
            let _this = this;
            this.codeType = "app";
            let bookid = getRegionCode(this.regionFullName);
            this.qrCodeShow = bool;
            let data = this.book.bookList[this.currentIdx];
            let city = this.regionFullName.replace('/','')
            this.$nextTick(()=>{
                let text = `https://tssm.wanweiedu.com/#/share?regionid=${bookid}`
                this.drawQRCode('coilingqrcode3',text,type,function(url){
                    _this.imageUrl.appImg = url
                    _this.imageName.app = `${data.year}${city}${data.bookTypeName}APP码`;
                })
            })
        },
        previewCode(type,bool){ //试题研究码预览
            let _this = this;
            this.codeType = "question";
            console.log(this.book,this.currentIdx,type)
            let data = this.book.bookList[this.currentIdx];
            console.log(data,this.regionFullName,regionCode,getRegionCode(this.regionFullName));
            // let bookid = getRegionCode(this.regionFullName)+data.year;
            // 原bookid = 地区代码 + 年 + bookTypeId（情景题、面对面...）
            let bookid = data.id;
            /* if(data.bookTypeName == "试题研究"){
                bookid+='1'
            }else if(data.bookTypeName == "面对面"){
                bookid+='2'
            }else if(data.bookTypeName == "情境题"){
                bookid+='3'
            } */
            
            this.qrCodeShow = bool;
            let city = this.regionFullName.replace('/','')
            this.$nextTick(()=>{
                let text = `${process.env.VUE_APP_SHARE_H5}/#/share?isNewQRCode=1&bookid=${bookid}&role=`
                // let text = `https://wwtsdev.wanweiedu.com/h5/#/share?bookid=${bookid}&role=`
                this.drawQRCode('coilingqrcode',text+"teacher",type,function(url){
                    _this.imageUrl.teacherImg = url
                    _this.imageName.teacher = `${data.year}${city}${data.bookTypeName}试题预览码老师`;
                })
                this.drawQRCode('coilingqrcode2',text+"student",type,function(url){
                    _this.imageUrl.studentImg = url
                    _this.imageName.student = `${data.year}${city}${data.bookTypeName}试题预览码学生`;
                })
            console.log("🐞 - book.vue:367 - url :", text+"teacher")
            })
        },
        drawQRCode(refName,text,type,callBack){ //画二维码以及二维码中间的logo
            const canvas = this.$refs[refName];
            QRCode.toCanvas(
                canvas,
                text,
                { errorCorrectionLevel:"H", width: '200rem', height: "200rem", margin: 1.5, colorLight: "#ffffff00",type:"image/png" },
                (error) => {
                    if (error) console.error(error);
                }
            );
            // 在二维码中间添加logo
            const ctx = canvas.getContext('2d');
            

            const logo = new Image();
            let url = '';
            switch(type){
                case '1':
                    logo.src = require('@/assets/images/logo_wanwei.png');break;
                case '2':
                    logo.src = require('@/assets/images/logo_question.png');break;
                case '3':
                    logo.src = require('@/assets/images/logo_toFace.jpg');break;
                default:
                    url = canvas.toDataURL();
                    callBack(url);
            }
            // logo.src = require('@/assets/images/logo_wanwei.png');
            logo.onload = function () {
                const logoSize = canvas.width * 0.2; // 根据需要调整logo尺寸
                const logoX = (canvas.width - logoSize) / 2;
                const logoY = (canvas.height - logoSize) / 2;

                // 定义矩形的位置和大小
                ctx.rect(logoX-3, logoY-3, logoSize+6, logoSize+6);
                
                // 设置填充颜色
                ctx.fillStyle = '#FFFFFF';
                
                // 填充矩形
                ctx.fill();
            
                // 绘制二维码
                ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);
            
                // 将生成的二维码插入到页面中
                url = canvas.toDataURL();
                callBack(url);
                // qrDataUrl.value = canvas.toDataURL();
            };
        },
        downloadImage(){    //普通下载二维码图片
            if(this.codeType == "app"){
                this.linkDownload(this.imageUrl.appImg,this.imageName.app)
            }else if(this.codeType == "question"){
                this.linkDownload(this.imageUrl.teacherImg,this.imageName.teacher)
                this.linkDownload(this.imageUrl.studentImg,this.imageName.student)
            }
        },
        batchDownImage(){   //批量下载二维码图片
            console.log(this.appChecked)
            console.log(this.questionChecked)
            if(this.appChecked){
                this.linkDownload(this.imageUrl.appImg,this.imageName.app)
            }
            if(this.questionChecked){
                this.linkDownload(this.imageUrl.teacherImg,this.imageName.teacher)
                this.linkDownload(this.imageUrl.studentImg,this.imageName.student)
            }
            if(!this.appChecked && !this.questionChecked){
                this.$message({
                    message: '请勾选要下载的二维码',
                    type: 'warning'
                });
            }
        },
        linkDownload(url,name){ //通过a标签进行二维码下载
            const a = document.createElement('a') // 动态创建a标签
            a.download = name // 下载名称
            a.href = url     // 设置下载路径
            // document.body.appendChild(a);
            a.click()  // 触发点击事件，使图片下载
            a.remove();
        },
        appCodeChange(data){    //app二维码复选框切换监听函数
            console.log(data)
            // if(!data){
            //     this.appRadio = '';
            // }else{
            //     this.appRadio = "1";
            //     this.previewAppCode(this.appRadio,false);
            // }
        },
        questionCodeChange(){   //试题预览二维码切换监听函数
            if(this.questionChecked){
                this.previewCode(this.questionRadio,false);
            }
        },
        radioClick(){   //logo单选框切换监听函数
            this.appChecked = true; //联动，选中复选框
            this.appCodeChange(true);   //触发复选框函数，执行预览函数绘制相应二维码获取到二维码url
        },
        option(command){
            if(command == '1'){
                this.title = `编辑题源（${this.regionFullName}）`
                this.newQuestionVisible = true
            }
            if(command == '2'){
                 this.$confirm('禁用后，将关闭该题源下模块、单元等各级启用权限', '是否禁用当前题源?', {
                distinguishCancelAndClose: true,
                confirmButtonText: '禁用',
                cancelButtonText: '取消',
                customClass:"customClass",
                confirmButtonClass: "btnConfirm",
                cancelButtonClass:'btnCancel'
                }).then(()=>{ 
                    this.$emit('enableBook','1')
                }).catch(()=>{
                })
            }
            if(command == '3'){
                console.log(this.book.bookList[this.currentIdx])
                this.$confirm('删除后，数据将被清除无法恢复', '是否删除当前题源？', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                customClass:"customClass",
                confirmButtonClass: "btnConfirm",
                cancelButtonClass:'btnCancel'
                }).then(()=>{
                    this.$emit('deleteBook',this.book.bookList[this.currentIdx])
                }).catch(()=>{
                })
            }
            if(command == '5'){
                this.qrCodeVosible = true
            }
            if(command == '4'){ //图片资源上传
                this.uploadVosible = true
            }
        },
        enableQuestion(){
            this.$confirm('启用后，还需要打开该题源下模块、单元等各级启用权限', '是否启用当前题源?', {
            distinguishCancelAndClose: true,
            confirmButtonText: '启用',
            cancelButtonText: '取消',
            customClass:"customClass",
            confirmButtonClass: "btnConfirm",
            cancelButtonClass:'btnCancel'
            }).then(()=>{ 
                this.$emit('enableBook','0')
            }).catch(()=>{})
        },
        enableCatalog(item, book){
            if(book.status=='1'){
                return
            }
            let content_1 = item.status=='0'?'禁用后，将无法显示当前模块':'启用后，显示当前模块'
            let content_2 = item.status=='0'?'禁用当前模块？':'启用当前模块？'
            let confirm_text = item.status=='0'?'禁用':'启用'
            this.$confirm(content_1, content_2, {
            distinguishCancelAndClose: true,
            confirmButtonText: confirm_text,
            cancelButtonText: '取消',
            customClass:"customClass",
            confirmButtonClass: "btnConfirm",
            cancelButtonClass:'btnCancel'
            }).then(()=>{ 
                this.$emit('enableCatalog', item)
            }).catch(()=>{})
        },
        dialogClose(){
            this.newQuestionVisible = false;
        },
        carouselChange(idx){
            this.currentIdx = idx
        },
        newOrUpdateQuestion(e){
            e.id =  this.book.bookList[this.currentIdx].id
             this.$emit("newOrUpdateQuestion", e)
            
        },
        toCatalog(book,type){
            book.regionId = this.$parent.bookItemObj.areaId
            if(book.status=='1'){
                return
            }

            let questionOptionsCopy = questionOptions.questionOptions; // 题源
            let options = questionOptions.options; // 题源
            console.log(this.book.bookList[this.currentIdx], questionOptionsCopy, options, type)

            let bookTypeIdNodes = this.book.bookList[this.currentIdx]['bookTypeIdNodes'];
            let questionSource = '';
            let questionOptionsTile = this.tile(questionOptionsCopy);
            for (let i = 0; i < bookTypeIdNodes.length; i++) {
                for (let ii = 0; ii < questionOptionsTile.length; ii++) {
                    if(bookTypeIdNodes[i]==questionOptionsTile[ii].value){
                        if(i==0){
                            questionSource = questionSource + questionOptionsTile[ii].label;
                        }else{
                            questionSource = questionSource + '/' + questionOptionsTile[ii].label;
                        }
                        
                    }
                }
            }

            let optionsTile = this.tile(options);
            let region = '';
            for (let i = 0; i < optionsTile.length; i++) {
                if(optionsTile[i].value==this.book.bookList[this.currentIdx]['regionId']){
                    region = optionsTile[i].label;
                }
                region= this.$parent.bookItemObj.regionFullName
            }
            
            let query = {
                bookId:this.book.bookList[this.currentIdx]['id'],
                region,
                regionId:book.regionId,
                questionSource,
                year:this.book.bookList[this.currentIdx]['year'],
                type:type?type:''
            }
            this.setStoreData(query.regionId,query.bookId,query.type,query.catalogId);

            console.log('query',query);
            this.$router.push({
                path:'/addModule',
                query
            })
        },
        setStoreData(regionId,bookId,type,catalogId){
            this.$store.commit('updateRegionId', regionId);
            this.$store.commit('updatebookId', bookId);
            this.$store.commit('updateCatalogType', type);
            this.$store.commit('updateCatalogId', catalogId);
        },
        // 平铺
        tile(arr){
            let tileArr = [];
            for (let i = 0; i < arr.length; i++) {
                tileArr.push(arr[i]);

                if(Object.prototype.hasOwnProperty.call(arr[i], "children") && arr[i].children.length){
                    tileArr.push(...this.tile(arr[i].children));
                }
            }
            
            return tileArr;
        }

    },
}
</script>
<style lang="scss" scoped>
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
        background: #0BAE6A;
        border:1px solid #0BAE6A;
        font-size: 14rem;
    }
    ::v-deep .el-radio__inner:hover{
        border:1px solid #0BAE6A;
        font-size: 14rem;
    }
    ::v-deep .el-radio__input.is-checked+.el-radio__label{
        color: #303133;
        font-size: 14rem;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background: #0BAE6A;
        border:1px solid #0BAE6A;
        font-size: 14rem;
    }
    ::v-deep .el-checkbox__inner:hover{
        border:1px solid #0BAE6A;
        font-size: 14rem;
    }
    ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
        color: #303133;
        font-size: 14rem;
    }
    ::v-deep .el-checkbox__label{
        font-size: 14rem;
    }
    ::v-deep .el-radio__label{
        font-size: 14rem;
    }
    ::v-deep .el-dialog__title {
        position: relative;
        line-height: 20rem!important;
        font-weight: 600;
        font-size: 18rem!important;
    }
    ::v-deep .el-dialog__title:before{
        top: 0 !important;
        bottom: 0 !important;
        left: 0rem !important;
        // right: 0 !important;
        margin: auto;
    }
    
    /* 覆盖Element UI上传进度条颜色 */
    ::v-deep .el-upload-list__item-thumbnail {
        object-fit: contain;
    }
    ::v-deep .el-progress-bar__inner {
    /* 设置进度条颜色为蓝色 */
        background-color: #0BAE6A !important;
    }
    .upload-demo{
        height: 220px;
    }
    .dialogBox{
        padding: 10rem 20rem 0;
        font-size: 14rem;
    }
    .btnBox{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50rem;
        font-size: 14rem;
    }
    .previewText{
        color: #0094FF;
        margin-left: 20rem;
        font-size: 14rem;
        cursor: pointer;
    }
    .checkBox{
        // margin-top: 16rem;
        margin-bottom: 16rem;
        font-size: 14rem;
    }
    .radioBox{
        padding-left: 20rem;
        margin-bottom: 16rem;
        font-size: 14rem;
    }
    .loadBtn{
        background: #0BAE6A;
        border: none;
        width: 199rem;
        height: 32rem;
        background: linear-gradient( 91deg, #0BAE5B 0%, #08C162 100%);
        border-radius: 6rem 6rem 6rem 6rem;
        color: #fff;
        font-size: 16rem;
    }

    .coilingQrCode{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        width: 100%;
    }
    .codeDialog{
       ::v-deep .el-dialog {
            // height: 500rem!important;
            height: auto!important;;
        }
    }
    .qrCodeBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .qrCodeText{
        margin-top: 20rem;
    }
    .qrCodeBtnBox{
        width: 100%;
        margin-top: 30rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 30rem;

        .el-button{
            width: 199rem;
            height: 32rem;
            background: linear-gradient( 91deg, #0BAE5B 0%, #08C162 100%);
            border-radius: 6rem 6rem 6rem 6rem;
            font-size: 14rem;
            padding: 0;
            line-height: 32rem;
            color: #fff;
        }
        .el-button:focus, .el-button:hover {
            font-size: 14rem;
            color: #fff;
        }
    }

    .uploadBtnBox{
        width: 100%;
        margin-top: 60rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .el-button{
            width: 76rem;
            height: 32rem;
            background: linear-gradient( 91deg, #0BAE5B 0%, #08C162 100%);
            border-radius: 6rem 6rem 6rem 6rem;
            font-size: 14rem;
            padding: 0;
            line-height: 32rem;
            color: #fff;
            margin-right: 0rem;
        }
        .el-button:focus, .el-button:hover {
            font-size: 14rem;
            color: #fff;
        }
    }
    .linkBox{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 35rem;

        .linkText{
            font-size: 14rem;
            color: #303133;
        }
        .linkContent{
            flex: 1;
            height: 32rem;
            line-height: 32rem;
            text-align: center;
            background: #ECECEC;
            border-radius: 6rem 6rem 6rem 6rem;
            // display: flex;
            // flex-direction: row;
            // align-items: center;
            padding: 0 15rem;
            font-size: 14rem;
            color: #303133;
            margin: 0 10rem 0 5rem;

            overflow: hidden;/*超出部分隐藏*/
            text-overflow:ellipsis;/* 超出部分显示省略号 */
            white-space: nowrap;/*规定段落中的文本不进行换行 */
            // width: 250px;/*需要配合宽度来使用*/
        }
        .linkIcon{
            width: 20rem;
            height: 20rem;
            cursor: pointer;
        }
    }

    .body_book{
        width: 372.5rem;
        height: 404rem;
        background: #FFF;
        position: relative;
    }
    .top{
        display: flex;
        height: 60rem;
        width:100%; 
        align-items: center;
        justify-content: center;
        .top-1{
            font-size: 20rem;
            font-weight: 600;
            margin-left:40rem;
            border-bottom: 4rem solid var(--primary-color);
            
        }
        .top-2{
            // position: relative;
            // // right:110rem;
            margin-left: 10rem;
            font-size: 12rem;

        }
    }
    .middle{
        height: 280rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        
        padding:20rem 20rem 0rem 20rem;
        .middle-1{
         
            .el-carousel {
            text-align: center;
            }

            .image{
                width: 88rem;
                height: 124rem;
                box-shadow:5rem 5rem 5rem rgba(0, 0, 0, 0.3);
            }
            p{
                color: #A8ABB2;
            }
            .disable_book{
                position: absolute;
                top: 30%;
                left: 30%;
                z-index: 5rem;
                font-size: 14rem;
                color:#ffffff;
                background: rgba(0, 0, 0, 0.7);
                width:73rem;
                height: 28rem;
                border-radius:14rem;
                line-height: 28rem;

            }

        }
        .middle-2{
            height: 70rem;
            // margin-top: 10rem;
            overflow-y: scroll;
            ul{
                padding:0rem 20rem 0rem 20rem; 
                margin:0rem; 
                height: 100%;
                // background: #d3dce6;
                // list-style: none;
                
                li{
                    height:35rem;
                    display: flex;
                    align-items: center;
                    position: relative;
                    justify-content: space-between;
                    // margin-bottom: 10rem;
                    .li-1{
                        flex: 1;
                    }
                    .li-2{
                        flex: 1;
                        overflow: hidden;/*超出部分隐藏*/
                        text-overflow:ellipsis;/* 超出部分显示省略号 */
                        white-space: nowrap;/*规定段落中的文本不进行换行 */
                    }
                    .li-1, .li-2{
                        font-size: 18rem;
                    }
                    .li-2-disable{
                        color:#A8ABB2;
                    }
                    .li-3_disabled{
                        width: 52rem;
                        height: 28rem;
                        font-size: 12rem;
                        color: #ff0000;
                       background:#F7E8E8;
                       border: none;
                    }
                    .li-3_enable{
                        width: 52rem;
                        height: 28rem;
                        font-size: 12rem;
                        color: #0BAE6A;
                        background:#E1FAE8;
                        border: none;
                    }
                    .li_3_disabled_all{
                        width: 52rem;
                        height: 28rem;
                        font-size: 12rem;
                        color: #A8ABB2 !important;
                        background:#E9E9E9 !important;
                        border: none;
                    }
                    .li-4{
                        width: 52rem;
                        height: 28rem;
                        font-size: 12rem;
                        color: #0094FF;
                        background: #E5F0FF;
                        border: none;
                    }
                   ::v-deep.el-button--mini, .el-button--mini.is-round{
                      padding: 7rem 15rem;
                    }
                }
                
            }
        }
    }
    .bottom{
        display: flex;
        justify-content: space-around;
        height: 45rem;
        align-items: center;
        .bottom-1{
            margin-top: -1rem;
        }
        .bottom-2{
            border: none !important;
            color:var(--primary-color);
            font-size: 16rem;
            &:hover{
              cursor:pointer  
            }
        }
    }
    .book_mask {
        z-index: 30;
        position: absolute;
        border-radius: 10rem;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        /* 按钮居中 */
        display: flex;
        justify-content: center;
        align-items: center; 
        .el-button{
            color: #FFF;
            background-image: var(--background-image);
            border: none !important;
            border-radius: 6rem;
            box-shadow: none !important;
            font-size: 18rem;
            width: 136rem;
            height: 55rem;
        }
        .image{
            width: 110rem;
            height: 110rem;
            position: absolute;
            top: -26rem;
            right: -26rem;
        }
    }    
    .el-carousel__item.is-in-stage .image{
        transform: scale(0.8,0.8);
    }
    .el-carousel__item.is-active p{
        color: var(--primary-color);
    }
    .el-carousel__item.is-active .image{
        transform: scale(1,1);
    }
    ::v-deep .el-carousel__arrow--left{
        top: 70rem;
        left: 0rem;
        width: 28rem;
        height: 28rem;
        color: var(--primary-color);
        background: #FFF;
        border: 2rem solid var(--primary-color) !important;
        [class^=el-icon-]{
            font-weight: 800;
        }
    }
    ::v-deep .el-carousel__arrow--right{
        top: 70rem;
        right: 0rem;
        color: var(--primary-color);
        width: 28rem;
        height: 28rem;
        background: #FFF;
        border:  2rem solid var(--primary-color) !important;
        [class^=el-icon-]{
            font-weight: 800;
        }

    }
    ::-webkit-scrollbar{
        width: 4rem;
        
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 3rem;
        background-color: #D9D9D9;
    }
  
    ::-webkit-scrollbar-track {
        background-color: #FFF;
    }
    // ::v-deep .el-carousel__arrow{
    //     background: #FFF;
    //     border: rem solid #02E9FF;
    // }

</style>
<style lang="scss">
    .btnConfirm{
        width: 76rem;
        height: 32rem;
        background: #0BAE6A !important;
        color:#fff !important;
        border: 1rem solid #0BAE6A !important;
        border-radius: 6rem;
    }
    .btnCancel{
        width: 76rem;
        height: 32rem;
        background: #fff !important;
        color:#0BAE6A !important;
        border: 1rem solid #0BAE6A !important;
        border-radius: 6rem;
        margin-left: 15rem;
    }
    .customClass{
        width:460rem;
        border-radius: 8rem;
        box-sizing: border-box;
        .el-message-box__header .el-message-box__title span{
            margin-left: 20rem;
            &::before{
                content:url(../static/warning.png); 
             
                position: relative;
                top:5rem;
                left: -15rem;
            }
        }
        .el-message-box__headerbtn .el-message-box__close{
            // color: #ff0000;
            transform: scale(1.4,1.4);
            margin-top: 10rem;
        }
        .el-message-box__title{
            font-size: 18rem;
            color: #000000;
            font-weight:bold;
            height: 30rem;
            span{
                position: absolute;
                top: 12rem;
            }
        }
        .el-message-box__content{
            font-size: 14rem;
            height: 24rem;
            p{
                margin-left: 48rem;
                position: absolute;
                top: -5rem;
            }
        }
    }
</style>